// app_client/src/store/uiStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 'persist' middleware'i sayesinde localStorage işlemini otomatik yapar.
// Manuel useEffect yazmana gerek kalmaz.
export const useUIStore = create(
  persist(
    (set) => ({
      isSidebarCollapsed: false,
      toggleSidebar: () => set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
    }),
    {
      name: 'ui-storage', // localStorage anahtar adı
    }
  )
);